import TLanguages from '../../templates/languages';

function Languages() {
  return <TLanguages></TLanguages>;
}

export default Languages;
